module.exports = __webpack_public_path__ + "img/Mb_exhibition.86b55a87.jpg";